/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationStateTown } from './OrganizationStateTown';
import {
    OrganizationStateTownFromJSON,
    OrganizationStateTownFromJSONTyped,
    OrganizationStateTownToJSON,
    OrganizationStateTownToJSONTyped,
} from './OrganizationStateTown';
import type { CreateLeadInfoRequestState } from './CreateLeadInfoRequestState';
import {
    CreateLeadInfoRequestStateFromJSON,
    CreateLeadInfoRequestStateFromJSONTyped,
    CreateLeadInfoRequestStateToJSON,
    CreateLeadInfoRequestStateToJSONTyped,
} from './CreateLeadInfoRequestState';
import type { OrganizationStateType } from './OrganizationStateType';
import {
    OrganizationStateTypeFromJSON,
    OrganizationStateTypeFromJSONTyped,
    OrganizationStateTypeToJSON,
    OrganizationStateTypeToJSONTyped,
} from './OrganizationStateType';

/**
 * 
 * @export
 * @interface OrganizationState
 */
export interface OrganizationState {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    state_id?: string;
    /**
     * 
     */
    type?: OrganizationStateType;
    /**
     * 
     */
    state?: CreateLeadInfoRequestState;
    /**
     * 
     */
    towns?: Array<OrganizationStateTown>;
}



/**
 * Check if a given object implements the OrganizationState interface.
 */
export function instanceOfOrganizationState(value: object): value is OrganizationState {
    return true;
}

export function OrganizationStateFromJSON(json: any): OrganizationState {
    return OrganizationStateFromJSONTyped(json, false);
}

export function OrganizationStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationState {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'state_id': json['state_id'] == null ? undefined : json['state_id'],
        'type': json['type'] == null ? undefined : OrganizationStateTypeFromJSON(json['type']),
        'state': json['state'] == null ? undefined : CreateLeadInfoRequestStateFromJSON(json['state']),
        'towns': json['towns'] == null ? undefined : ((json['towns'] as Array<any>).map(OrganizationStateTownFromJSON)),
    };
}

export function OrganizationStateToJSON(json: any): OrganizationState {
    return OrganizationStateToJSONTyped(json, false);
}

export function OrganizationStateToJSONTyped(value?: OrganizationState | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'state_id': value['state_id'],
        'type': OrganizationStateTypeToJSON(value['type']),
        'state': CreateLeadInfoRequestStateToJSON(value['state']),
        'towns': value['towns'] == null ? undefined : ((value['towns'] as Array<any>).map(OrganizationStateTownToJSON)),
    };
}

